import { TEXTS } from '../../constants';
import {
  SectionWrapper,
  ContentWrapper,
  SectionHeading,
  StoryCard,
  StoryText,
} from './styles';

const PersonalStorySection = ({ personalStory }) => {
  if (!personalStory) return null;

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionHeading>{TEXTS.personalStory.title}</SectionHeading>
        <StoryCard>
          <StoryText>{personalStory}</StoryText>
        </StoryCard>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default PersonalStorySection;
